import HeroSection from '@/v2/components/sections/how-ship-and-storage-works/hero-section'
import HowShipAndStorageWorksTabs from '@/v2/components/sections/how-ship-and-storage-works/how-ship-and-storage-works-tabs-section'
import TwoCardsBannerSection from '@/v2/components/sections/how-ship-and-storage-works/two-cards-banner-section'
import {
  heroSectionContent,
  tabs,
  twoCardsBannerContent
} from '@/v2/constants/pages/public-pages/how-ship-and-storage-works'

interface HowShipAndStorageWorksPageProps {}

const HowShipAndStorageWorksPage: React.FC<HowShipAndStorageWorksPageProps> = () => {
  return (
    <>
      <HeroSection {...heroSectionContent} />
      <HowShipAndStorageWorksTabs tabs={tabs} />
      <TwoCardsBannerSection {...twoCardsBannerContent} />
    </>
  )
}

export default HowShipAndStorageWorksPage
